import { useNavigate, useParams } from 'react-router-dom'

import { getNLUTabs, IRequestGetNLUTabs } from '../../api/nluData'
import useApiCall from '../../api/useApiCall'
import { useNLUDataStore } from '../../stores/nluDataStore'
import LoadingSection from '../LoadingSection/LoadingSection'

import NLUDataContent from './NLUDataContent/NLUDataContent'
import NLUDataHeader from './NLUDataHeader/NLUDataHeader'

import styles from './nlu-data.module.scss'

function NLUData() {
    const { tab } = useParams()

    const navigate = useNavigate()

    const [, { setNLUDataTabs, setEntities, setIntents, setIntentsStatus }] =
        useNLUDataStore()

    const [{ loading }] = useApiCall(getNLUTabs, handleGetNLUTabs)

    function handleGetNLUTabs(data: IRequestGetNLUTabs) {
        const { entity_labels: entities, intents, tab_names: tabs } = data

        setNLUDataTabs(tabs)
        setEntities(entities)
        setIntents(intents.map((intent) => intent.name))
        setIntentsStatus(intents)

        if (!tab) {
            const [defaultTab] = tabs
            navigate(defaultTab)
        }
    }

    return (
        <main className={styles.nluData}>
            <NLUDataHeader />
            {loading ? <LoadingSection /> : <NLUDataContent />}
        </main>
    )
}

export default NLUData
